module.exports = __webpack_public_path__ + "static/img/22.819bd290.png";